import React, { Component } from 'react';
import AddPlayerForm from './AddPlayerForm'
import AddressForm from './AddressForm';
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { get } from 'lodash'
import { countryApiAction } from '../../commonAction/countryApiAction'
import UtilService from '../utils/utils';
import { playerAction, getClubList } from "./playerAction";
import constant from '../../constants/constant';
import { RESET, EDIT_DELETE_RESET } from '../../constants/type'
import $ from 'jquery';
// import SuccessPopup from '../view/SuccessPopup';
import { getExistingPlayerDetailsAction, addMemberCredit, getSinglePlayerDetailsAction } from './managePlayerAction';
import { NavLink } from "react-router-dom";
import { toast } from 'react-toastify';

const playerInitialValue = {
    fullName: "",
    playeraddress: "",
    mobile: "",
    countryCode: "",//Need data
    dob: null,
    // currency: "",
    highestBilliardsPracticeBreak: 0,
    highestSnookerPracticeBreak: 0,
    email: "",
    height: 0,
    highestBilliardsTournamentBreak: 0,
    highestSnookerTournamentBreak: 0,
    credit: 0,
    discount: 0,
    gender: "M",
    styleOfPlaying: "R",
    associate_player: true,
    roleId: 5,
    clubs: [],
    statusId: 4,
    isPlayerEmailIdExist: false,
    membershipType: "HOURLY",
    isReferee:false
}
const playerValidationMessage = {
    fullName: "Member Name is Required",
    mobile: "Mobile Number is Required",
    dob: "Date of birth Required",
    countryCode: "91",
    highestBilliardsPracticeBreak: "Highest Billiards practice break is Required",
    highestSnookerPracticeBreak: "Highest Snooker practice break is Required",
    playeraddress: "Member address is Required",
    email: "Email is Required",
    height: "Member Height is Required",
    highestBilliardsTournamentBreak: "Highest Billiards tournament break is Required",
    highestSnookerTournamentBreak: "Highest Snooker tournament break is Required",
    membershipType: "Membership Type is required",
    // currency: "Currency is Required",
    gender: "",
    styleOfPlaying: "",
    associate_player: true,
    roleId: 5,
    clubs: [],//need 
    statusId: 4,
    isPlayerEmailIdExist: false,
}
let isOtherIdx = false;


class AddPlayer extends Component {

    constructor(props) {
        super(props)
        this.props.dispatch({ type: RESET });
        const editPlayer = this.getEditPlayerData()
        //initilize state value
        this.initialStateData(editPlayer, false)
        this.playerAddressData = null;
        this.clubId = null
        this.isOther = null;
        if (UtilService.isPabsaAdmin() && this.props.location.state) {
            this.clubId = this.props.location.state.clubid ? this.props.location.state.clubid : ''
        }
        this.roleId = UtilService.getUserDetail(constant.ROLE_ID)
    }
    initialStateData = (editPlayer, isUpdateState) => {
        let addPlayer = editPlayer.playerViewData ? editPlayer.playerViewData : {};
        if (addPlayer !== null && !addPlayer.hasOwnProperty("membershipType")) {
            var clubIdx = this.props.location.state ? this.props.location.state.clubid : "";
            isOtherIdx = this.props.location.state ? this.props.location.state.isOther : "";
            var club = addPlayer.clubs
            // membershipType = club && club.length > 0 ? membershipType : "";
            if (club && club.length > 0) {
                for (let i = 0; i < club.length; i++) {
                    if (club[i].clubId == clubIdx) {
                        let membershipType = club[i].membershipType
                        addPlayer["membershipType"] = membershipType;
                    }
                    else {
                        addPlayer["membershipType"] = "HOURLY";
                        if (UtilService.isPabsaAdmin() && club[i]?.membershipType) {
                            let membershipType = club[i].membershipType
                            addPlayer["membershipType"] = membershipType;
                        }
                    }
                }
            }
            else {
                addPlayer["membershipType"] = "HOURLY";
            }
        }
        var stateDataWithValues = {
            submitted: false,
            errors: {},
            addPlayer: editPlayer.isPlayerViewData ? addPlayer : playerInitialValue,
            addressForm: {
                streetAddress1: editPlayer.isPlayerViewData ? editPlayer.playerViewData.streetAddress1 : "",
                streetAddress2: editPlayer.isPlayerViewData ? editPlayer.playerViewData.streetAddress2 : "",
                city: editPlayer.isPlayerViewData ? editPlayer.playerViewData.city : "",
                state: editPlayer.isPlayerViewData ? editPlayer.playerViewData.state : "",
                zip: editPlayer.isPlayerViewData ? editPlayer.playerViewData.zip : "",
                countryId: editPlayer.isPlayerViewData ? UtilService.getCountryName(editPlayer.playerViewData.countryId) : "",
            },
            disableAllFieldsInExistsEmail: editPlayer.isPlayerViewData,
            isPlayerEmailIdExist: false,
            isRegister: this.props.isRegister === 'Y' ? true : false
        }

        if (isUpdateState) {
            this.setState(stateDataWithValues)
        } else {
            this.state = stateDataWithValues
        }
    }
    setUpdatedAddress = () => {
        const { addressForm } = this.state;
        var addressData = {}
        let mergeValue = Object.keys(addressForm).map((key, idx) => {
            addressData = {
                ...addressData,
                [key]: addressForm[key]
            }
            return addressForm[key]
        })
        this.submit_address(mergeValue.join(" "), addressForm)

    }
    async componentDidMount() {
        let states = this.props.location.state
        if (states != null) {
            let playerId = states.playerId,
                clubid = states.clubid,
                type = states.type,
                isOther = states.isOther;
            // setTimeout(()=>{
            await this.props.dispatch(getSinglePlayerDetailsAction(playerId, type, this.props.history, clubid, isOther))

            // },1500)

        }

        let countryApiData = await UtilService.getCountryList();

        if (countryApiData === null) {
            await this.props.dispatch(countryApiAction())
            countryApiData = get(this.props, 'countryApiReducer.countryApiData', null);
        }
        const editPlayerUpdate = this.getEditPlayerData()
        if (editPlayerUpdate.isPlayerViewData)
            this.initialStateData(editPlayerUpdate, editPlayerUpdate.isPlayerViewData)

        const editPlayer = this.getEditPlayerData()
        let parsedCountryApiData = countryApiData ? JSON.parse(countryApiData) : null;
        let initialCountryId = (parsedCountryApiData && parsedCountryApiData.countries && parsedCountryApiData.countries.length > 0) ? parsedCountryApiData.countries[0].countryCode : ''
        const { addPlayer } = this.state
        this.setState({
            addPlayer: {
                ...addPlayer,
                countryCode: editPlayer.isPlayerViewData ? editPlayer.playerViewData.countryCode : initialCountryId,
            }
        })

        //hit club list api
        if (!this.state.isRegister) {
            await this.props.dispatch(getClubList())
        }
        if (this.getEditPlayerData().isPlayerViewData) {
            this.setUpdatedAddress()
        }


    }
    onPlayerAddedSuccess = () => {
        $('.modal').modal('hide')
        //this.props.history.push("/player");
        const { isRegister } = this.state
        this.setState({ isRegister: false })
        if (!isRegister) {
            this.props.history.push("/player")
        }
    }
    onAddPlayerSubmit = (event) => {
        event.preventDefault();

        const { addPlayer, isRegister } = this.state
        let error = {};
        this.setState({
            submitted: true,
            errors: error
        });

        if (addPlayer.playerId == null) {
            const stateKeyList = Object.keys(addPlayer);
            for (var i = 0; i < stateKeyList.length; i++) {
                if (!(stateKeyList[i] === 'streetAddress2'
                    || stateKeyList[i] === "clubs"
                    || stateKeyList[i] === "streetAddress1"
                    || stateKeyList[i] === "city"
                    || stateKeyList[i] === "state"
                    || stateKeyList[i] === "zip"
                    || stateKeyList[i] === "countryId"
                    || stateKeyList[i] === "dob"
                    || ((isRegister || !addPlayer.associate_player) && stateKeyList[i] === "membershipType")
                )) {
                    if (addPlayer[stateKeyList[i]].length === 0) {
                        error[stateKeyList[i]] = playerValidationMessage[stateKeyList[i]]
                        return;
                    }
                }
            }
        } else if (!isRegister && addPlayer.playerId !== null && addPlayer.membershipType == null) {
            error['membershipType'] = playerValidationMessage['membershipType']
            return;
        }
        if (!UtilService.validateEmail(addPlayer.email)) {
            error['email'] = "Invalid Email"
            return
        } else {
            if (addPlayer.hasOwnProperty('playeraddress')) {
                const playeraddress = addPlayer.playeraddress
                delete addPlayer.playeraddress;
                this.playerAddressData = null
                this.playerAddressData = playeraddress
            }
            var playerObjectData = { ...addPlayer, ...this.playerAddressData }
            //add DOB in millSec
            if (!(playerObjectData.dob === "" || playerObjectData.dob === null))
                playerObjectData.dob = UtilService.getDateIntoTimeStampInMillSec(playerObjectData.dob)
            //add countryId

            if (playerObjectData.countryId !== '')
                playerObjectData.countryId = UtilService.getCountryId(playerObjectData.countryId)
            //add clubId value
            if (this.roleId === constant.PABSA_SUPER_ADMIN_VALUE || this.roleId === constant.PABSA_ADMIN_VALUE) {
                // if (playerObjectData.clubId === 0 || playerObjectData.clubId === "0") {
                //     playerObjectData.clubId = null
                // }
            } else {
                //Not PABSA SUPER ADMIN  
                let userClubId
                if (UtilService.getInfoFromStorage('localstorage', constant.CLUBS)) {
                    userClubId = UtilService.getInfoFromStorage('localstorage', constant.CLUBS)[0].clubId
                } else {
                    userClubId = null
                }

                if (playerObjectData.associate_player) {
                    playerObjectData.clubs = []
                    playerObjectData.clubs.push(userClubId);
                }
                else {
                    playerObjectData.clubs = []
                }
            }
            this.props.dispatch(playerAction(playerObjectData, this.getEditPlayerData().isPlayerViewData, isRegister));
        }
    }

    handleChangeDOB = date => {
        const { addPlayer } = this.state
        this.setState({
            submitted: false,
            errors: {},
            addPlayer: {
                ...addPlayer,
                dob: date
            }
        })
    };

    submit_address = (data, addressData) => {

        let addTextField = document.querySelector('#addressFormValue');
        if (data !== null) {
            let replace = data.replace(/null/g, '')
            addTextField.textContent = replace
            const { addPlayer } = this.state
            this.setState({
                submitted: false,
                errors: {},
                addPlayer: {
                    ...addPlayer,
                    playeraddress: addressData
                }
            })
        } else {
            addTextField.textContent = "+ Add address details"
        }
    }
    handleChangeEvent = (event) => {
        const target = event.target;
        const name = target.name;
        let value = target.type === "checkbox" ? target.checked : target.value.trimStart();
        const { addPlayer } = this.state
        if (name === "fullName" && value.length > 100) {
            toast.warn("The member name shouldn't be more than 100 characters.");
            return;
        } else if (name === "height") {
            if (value.length > 3 && value * 1 > 999.99) {
                return
            } else if (value * 1 < 1 && value) {
                let regex = /^[0]?\.?\d{0,2}$/
                if (!regex.test(value) && value) return
            }
            else if (value * 1 >= 1) {
                let regex = /^[1-9][0-9]*\.?\d{0,2}$/
                if (!regex.test(value) && value) return
            }
        } else if (name === 'credit') {
            if (value.length > 10 && value * 1 > 9999999999.99) {
                return
            } else if (value * 1 < 1 && value) {
                let regex = /^[0]?\.?\d{0,2}$/
                if (!regex.test(value) && value) return
            }
            else if (value * 1 >= 1) {
                let regex = /^[1-9][0-9]*\.?\d{0,2}$/
                if (!regex.test(value) && value) return
            }
        }
        if (name === "discount" && value > 100) {
            return
        }
        if (name === "discount") {
            // value = value.length > 3 ? value.slice(0, 5) : value;
            if (value > 1) {
                value = Math.floor(value)
            }
        }
        if(name === "email"){
            value = value.trim();
        }
        this.setState({
            submitted: false,
            errors: {},
            addPlayer: {
                ...addPlayer,
                [name]: value
            }
        })
    }

    getAlreadyExistsPlayerInfo = async () => {

        let playerEmail = this.state.addPlayer.email;
        await this.props.dispatch(getExistingPlayerDetailsAction(playerEmail))
        setTimeout(() => {
            $('.modal').modal('hide');
            const editPlayer = this.getEditPlayerData()
            if (editPlayer.isPlayerViewData) {
                this.initialStateData(editPlayer, editPlayer.isPlayerViewData)
                const { addPlayer } = this.state
                // this.props.userDetailsReducer.successResponse = null
                //this.props.apiReducer.editApiSuccess = false
                if (!UtilService.isPabsaAdmin()) {
                    this.setState({
                        addPlayer: {
                            ...addPlayer,
                            associate_player: true
                        }
                    })
                }

                this.setState({
                    addPlayer: {
                        ...addPlayer,
                        isPlayerEmailIdExist: true
                    }
                })
                this.setUpdatedAddress()
            }
        }, 1000);
    }
    back_press = () => {
        this.props.history.push('/player')
    }

    onSelect = (selectedList, selectedItem) => {
        this.setClubIdIntoState(selectedList)
        setTimeout(() => {
            let ele = document.getElementById('multiselectContainerReact');
            document.querySelector('._3vLmCG3bB3CM2hhAiQX1tN, ._1YkOwrSkIvJIAvNNRNP3P5').style.bottom = (ele.offsetHeight + 5) + 'px'
        }, 100);

    }

    onRemove = (selectedList, removedItem) => {
        this.setClubIdIntoState(selectedList)
        setTimeout(() => {
            let ele = document.getElementById('multiselectContainerReact');
            document.querySelector('._3vLmCG3bB3CM2hhAiQX1tN, ._1YkOwrSkIvJIAvNNRNP3P5').style.bottom = (ele.offsetHeight + 5) + 'px'
        }, 100);
    }

    setClubIdIntoState = (clubListObjectArray) => {
        const clubListId = clubListObjectArray.map(clubList => clubList.clubId)
        const { addPlayer } = this.state
        this.setState({
            addPlayer: {
                ...addPlayer,
                clubs: clubListId
                // clubs: clubListObjectArray
            }
        })
    }

    clearPopup = () => {
        $('.modal').modal('hide');
        this.setState({ isRegister: false })
    }

    resetAllFields = () => {
        const editPlayer = '' //this.getEditPlayerData()
        //initilize state value
        this.initialStateData(editPlayer, true)
        let addTextField = document.querySelector('#addressFormValue');
        addTextField.innerHTML = " <span class='address-placeholder'> + Add address details</span>"

        this.setState({
            resetField: true
        })

        setTimeout(() => {
            this.setState({
                resetField: false
            })
        }, 100);

        if (this.state.isRegister) {
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.isRegister = false;
        }
    }
    memberCreditAmount = async (req) => {
        let states = this.props.location.state;
        let userDetails = JSON.parse(localStorage.getItem(constant.CURRENT_USER));
        const data =
        {
            "creditAmount": req,
            "memberId": states?.detail?.playerId,
            "creditBy": userDetails?.userId
        }
        await this.props.dispatch(addMemberCredit(data));
        await this.props.dispatch(getSinglePlayerDetailsAction(data?.memberId, constant.EDIT, this.props.history, states?.clubid));
        //     setTimeout(() => {
        //         this.props.dispatch(getSinglePlayerDetailsAction(data?.memberId, constant.EDIT, this.props.history, states?.clubid));
        // }, 2000)
        setTimeout(() => window.location.reload(), 1000)


    }

    render() {
        const {
            errors,
            submitted,
            addPlayer,
            addressForm,
            disableAllFieldsInExistsEmail,
            isRegister,
            resetField
        } = this.state
        const successMsg = get(
            this.props,
            "apiReducer.apiSuccesData",
            null
        );
        const apiSuccess = get(
            this.props,
            "apiReducer.isApiSuccess",
            false
        );
        if (apiSuccess) {
            $('#success_popup').modal('show')
        }
        let popUpMessage
        if (apiSuccess) {
            if (successMsg instanceof Object) {
            } else
                popUpMessage = successMsg
        }

        return (
            <React.Fragment>

                {isRegister ?
                    <button type="button" className="close popup-close-btn" data-dismiss="modal" aria-label="Close" onClick={this.resetAllFields}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                            <path d="M5.314 6.829l5.671 5.671-5.671 5.67a1.071 1.071 0 001.515 1.515l5.671-5.67 5.671 5.671a1.071 1.071 0 001.515-1.515L14.015 12.5l5.671-5.671a1.071 1.071 0 00-1.516-1.515l-5.67 5.671-5.671-5.671a1.071 1.071 0 00-1.515 1.515z" transform="translate(-5 -5)" fill="#666" />
                        </svg>
                    </button> :
                    ""
                }
                <AddPlayerForm
                    getalreadyexistsplayerinfo={this.getAlreadyExistsPlayerInfo}
                    disableallfieldsinexistsemail={disableAllFieldsInExistsEmail}
                    onAddPlayerSubmit={this.onAddPlayerSubmit}
                    handleChangeEvent={this.handleChangeEvent}
                    errors={errors}
                    submitted={submitted}
                    addPlayer={addPlayer}
                    handleChangeDOB={this.handleChangeDOB}
                    ui={this.props.ui}
                    apiReducer={this.props.apiReducer}
                    clubNameList={this.getClubNameList().club_list_data}
                    isUpdate={this.getEditPlayerData().isPlayerViewData}
                    back_press={this.back_press}
                    selectedClubId={this.clubId}
                    onselect={this.onSelect}
                    onremove={this.onRemove}
                    isRegister={isRegister}
                    resetAllFields={this.resetAllFields}
                    memberCreditAmount={this.memberCreditAmount}
                    isOtherIdx={isOtherIdx}
                />
                <AddressForm
                    address_submit={this.address_submit}
                    submit_address={this.submit_address}
                    addressForm={addressForm}
                    isRegister={isRegister}
                    resetField={resetField}
                />
                <div className="modal fade" id="success_popup" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="d-table w-100">
                        <div className="d-table-cell">
                            <div className="modal-dialog  modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-body p-0 border-0 mb-3">

                                        {isRegister ?
                                            <div>
                                                <p className="text-center m-0 text-success robotomedium">
                                                    Registration completed successfully
                                                </p>
                                                <p className="text-center">
                                                    Please check your email <strong>{addPlayer.email}</strong> and click on the link to set your account password.
                                                </p>
                                            </div> :
                                            <p className="text-center">
                                                {/* {
                                                    popUpMessage
                                                } */}
                                                {typeof (successMsg) != 'object' ? successMsg : ""}
                                            </p>
                                        }
                                    </div>
                                    <div className="modal-footer p-0 border-0 justify-content-center">
                                        {isRegister ?
                                            <NavLink className="btn red-btn" to="/login" onClick={() => { this.clearPopup() }}>OK</NavLink> :
                                            <button
                                                className="btn login-btn pl-4 pr-4 m-0"
                                                onClick={() => { this.onPlayerAddedSuccess() }}
                                            >
                                                OK, Thanks!
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* onClick={() => { this.onPlayerAddedSuccess() }} */}

                {/* <SuccessPopup addClubSuccessMsg={successMsg} onClickOk={this.onPlayerAddedSuccess} /> */}
            </React.Fragment>
        );
    }

    componentWillUnmount() {
        this.props.dispatch({ type: EDIT_DELETE_RESET });
        this.props.dispatch({ type: RESET });
        $('.modal').modal('hide');
        $('.modal-backdrop').remove();
    }

    getEditPlayerData() {
        if (this.props.isRegister === 'Y') {
            this.props.apiReducer.editPlayerApiSuccesData = null;
            this.props.apiReducer.editPlayerApiSuccess = false;
            this.props.location.state = null;
        }
        let playerViewData = get(
            this.props,
            "apiReducer.editPlayerApiSuccesData",
            null
        );

        let isPlayerViewData = get(
            this.props,
            "apiReducer.editPlayerApiSuccess",
            false
        );
        let states = this.props.location.state
        if (states != null) {
            let editPlayerData = states.detail
            playerViewData = editPlayerData
            isPlayerViewData = true
        }

        //add some key for update player use
        if (isPlayerViewData) {
            playerViewData.associate_player = true
            //  playerViewData.publicPlayerUpdate = playerViewData.publicPlayer
            if (playerViewData.dob) {
                playerViewData.dob = new Date(playerViewData.dob)
                playerViewData.isPlayerEmailIdExist = false
            }
        }
        return { "playerViewData": playerViewData, "isPlayerViewData": isPlayerViewData }
    }
    getClubNameList() {

        const isClubList = get(
            this.props,
            "apiReducer.clubNameListApiSuccess",
            false
        );

        const clubListData = get(
            this.props,
            "apiReducer.clubNameListApiSuccesData",
            null
        );
        return { "is_club_list": isClubList, "club_list_data": clubListData }
    }

    IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}
const mapStateToProps = state => ({
    countryApiReducer: state.countryApiReducer,
    ui: state.ui,
    apiReducer: state.apiReducer
});

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(AddPlayer);

